<div class="container">
    <div class="container__option" fxLayout="row" fxLayoutAlign="start center">
        <i
            class="fa-solid fa-exclamation-circle"
            [matTooltip]="
                'Análise percentual de cada conta em relação ao período selecionado.'
            "
        ></i>
        <span class="text-14-regular color-text-primary">
            Análise Horizontal
        </span>
        <span fxFlex></span>
        <mat-slide-toggle
            [hideIcon]="true"
            [(ngModel)]="form.analysisHorizontal"
            (ngModelChange)="onFormChange()"
        ></mat-slide-toggle>
    </div>
    <div class="container__option" fxLayout="column">
        <div fxLayout="row" fxLayoutAlign="start center" class="gap-8">
            <i
                class="fa-solid fa-exclamation-circle"
                [matTooltip]="
                    'Análise de representatividade de cada conta em relação ao Total da conta correspondente a qual ela pertence, ATIVO ou PASSIVO.'
                "
            ></i>
            <span class="text-14-regular color-text-primary">
                Análise Vertical
            </span>
            <span fxFlex></span>
            <mat-slide-toggle
                [hideIcon]="true"
                [(ngModel)]="form.analysisVertical"
                (ngModelChange)="onFormChange()"
            ></mat-slide-toggle>
        </div>
        @if (!config.hideReference) {
            <mat-radio-group
                aria-label="Referencia Analise Vertical"
                [(ngModel)]="form.verticalReference"
                (ngModelChange)="onFormChange()"
                [disabled]="!form.analysisVertical"
                [class.disabled]="!form.analysisVertical"
            >
                @if (options().source === "accounting") {
                    <mat-radio-button value="RECEITA BRUTA"
                        ><span class="text-14-regular color-text-primary"
                            >Receita Bruta</span
                        ></mat-radio-button
                    >
                } @else {
                    <mat-radio-button value="RECEITAS OPERACIONAIS"
                        ><span class="text-14-regular color-text-primary"
                            >Receitas Operacionais</span
                        ></mat-radio-button
                    >
                }
                <mat-radio-button value="RECEITA LIQUIDA">
                    <span class="text-14-regular color-text-primary"
                        >Receita Líquida</span
                    ></mat-radio-button
                >
            </mat-radio-group>
        }
    </div>
</div>
